export class User{

    public cpf: string;
    public login: string;
    public nome: string;
    public senha: string;

    constructor() { }

}


// WEBPACK FOOTER //
// ./src/app/model/user.ts